import React from "react";
import Typography from "@mui/material/Typography";

export interface IPageTitleProps {
    header: string;
}

export const PageTitle = ({ header }: IPageTitleProps) => {
    return (
        <>
            <Typography variant="h2" sx={{ color: "primary.dark" }}>
                {header}
            </Typography>
        </>
    );
};
